import CancelAppointmentModal from "./CancelAppointmentModal";

export default CancelAppointmentModal;

export * from "./CancelAppointmentModal";
